export default __webpack_public_path__ + "static/media/less-plain-wordmark.d2230708.svg";